module.exports = __webpack_public_path__ + "static/images/info-yellow.e4bcf91924003fd74467772d23551fdd.svg";